module.exports = __webpack_public_path__ + "img/4-highlightings.279ee74a.svg";